import { AxiosResponse } from 'axios'

export const getFileNameFromBlob = (file: AxiosResponse<File>) => {
   const contentDisposition = (file.headers as any).get('Content-Disposition')
   let fileName = 'unknown'

   if (contentDisposition && contentDisposition.includes('attachment')) {
      // Regex ile dosya adını çıkar
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)
      if (matches != null && matches[1]) {
         fileName = matches[1].replace(/['"]/g, '')
      }
   }

   return fileName
}

export const blobToString = async (blob: Blob) => {
   return new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as any)
      reader.onerror = () => reject(reader.error)
      reader.readAsText(blob)
   })
}
